module.exports = __webpack_public_path__ + "img/illustration-ptt-user.36369bf0.png";